export enum CollateralStrategyType {
  BullCall = 1,
  CoveredCall = 3,
}

export type CollateralStrategyRow = {
  id: string;
  accountName: string;
  strategyType: CollateralStrategyType;
  collateralSymbolIsin: string;
  collateralSymbolName?: string | null;
  baseSymbolIsin?: string | null;
  baseSymbolName?: string | null;
  quantity: number;
  updatedAt: string;
};

export type VirtualOmsEventLogRow = {
  requestedAt: string;
  operation: string;
  accountName: string;
  strategyType?: CollateralStrategyType | "BullCall" | "CoveredCall" | null;
  collateralSymbolIsin?: string | null;
  collateralSymbolName?: string | null;
  baseSymbolIsin?: string | null;
  baseSymbolName?: string | null;
  quantityDelta?: number | null;
  quantity?: number | null;
  chanceRefId?: number | null;
  result: string;
};
